import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import Icon from 'ui/atoms/Icon/Icon';
import PropTypes from 'prop-types';
import TextHtml from 'ui/atoms/TextHtml/TextHtml';
import React from 'react';

const DialogPersonalizeProgram = ({ t, open = false, hasPersonalizedProgram, courseName, onCancel = () => {}, onSuccess = () => {} }) => {
  return (
    <div>
      <Dialog
        isOpen={open}
        ariaLabel={t('new-course:Personalize')}
        size="l"
        className="dialog-personalize-program"
        onClose={onCancel}
        onCancel={onCancel}
        onSuccess={onSuccess}
        buttonTextSuccess={hasPersonalizedProgram ? t('course:Use my version') : t('course:Create my version')}
      >
        <div className="personalize-program__wrapper">
          <div className="personalize-program__head">
            <Icon name="pencil" color="primary" size="xl" />
            <h2 className="personalize-program__head-title">{t('new-course:Personalize')}</h2>
          </div>
          {hasPersonalizedProgram ? (
            <div className="personalize-program__content">
              <div className="personalize-program__subhead">
                <TextHtml text={t('course:Use personalized version of x', { name: courseName })} />
              </div>
            </div>
          ) : (
            <div className="personalize-program__content">
              <div className="personalize-program__subhead">{t('course:With this action you create your own version of the program')}</div>
              <ul className="personalize-program__list">
                <li className="personalize-program__entry">
                  <div className="personalize-program__entry-icon">
                    <Icon name="check" color="primary" size="xl" />
                  </div>
                  <div className="personalize-program__entry-text">{t('course:Create new units, lessons and exercises')}</div>
                </li>
                <li className="personalize-program__entry">
                  <div className="personalize-program__entry-icon">
                    <Icon name="check" color="primary" size="xl" />
                  </div>
                  <div className="personalize-program__entry-text">{t('course:Personalize the learning experience in an agile and flexible way')}</div>
                </li>
                <li className="personalize-program__entry">
                  <div className="personalize-program__entry-icon">
                    <Icon name="check" color="primary" size="xl" />
                  </div>
                  <div className="personalize-program__entry-text">{t('course:The original version will always be available in the library')}</div>
                </li>
              </ul>
              <div className="personalize-program__entry">
                <div className="personalize-program__entry-text">{t('course:Do you want to create your own version?')}</div>
              </div>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
};

DialogPersonalizeProgram.propTypes = {
  courseName: PropTypes.string,
  hasPersonalizedProgram: PropTypes.bool,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
  open: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default DialogPersonalizeProgram;
